export function convertUrlEncodedPhotoToBlob(photo: string | undefined): Blob {
    const [header, content] = (photo?.split(",") ?? []) as Array<string | undefined>;
    const [_, mimeBase] = (header?.split(":") ?? []) as Array<string | undefined>;
    const [mimeType] = (mimeBase?.split(";") ?? []) as Array<string | undefined>;
    const buffer = base64ToArrayBuffer(content ?? "");
    return new Blob([buffer], { type: mimeType });
}

function base64ToArrayBuffer(base64: string) {
    const binaryString = atob(base64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len); // Use Uint8Array directly
    for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes.buffer; // Return the ArrayBuffer
}
